<template>
    <el-dropdown @command="handleCommand" v-if="showCreateButton">
      <span v-if="isShowButton" class="el-dropdown-link">
        {{ createName }}
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-button
        v-else
        :type="buttonType"
        :size="buttonSize"
        style="font-size: 14px;margin-right: 5px;background:rgb(35,185,124);border:1px solid transparent;"
      >
        <i class="el-icon-plus el-icon--right"></i>
        {{ createName }}
        <!-- <i class="el-icon-arrow-down el-icon--right"></i> -->
      </el-button>
      <el-dropdown-menu slot="dropdown" style="height: 290px;">
        <el-scrollbar style="height: 100%;">
          <el-dropdown-item
            v-for="(item, index) in taskTypeList"
            :key="index"
            :command="item.ID"
            :icon="'iconfont icon-' + item.ICON"
          >{{ item.NAME }}</el-dropdown-item>
        </el-scrollbar>
      </el-dropdown-menu>
      <CreateTask ref="CreateTask" :RelationRecordId="RelationRecordId" @getValue="Success"></CreateTask>
    <CreateTaskForm ref="CreateTaskForm" @success="Success"></CreateTaskForm>
    </el-dropdown>
</template>

<script>
export default {
  name: "CreateTaskDropdown",
  data() {
    return {
      createName: "创建任务",
      taskTypeList: JSON.parse(localStorage.getItem("TaskType"))
        // ? JSON.parse(localStorage.getItem("TaskType")).filter(
        //     (item) => item.CLASSID == "fuwu"
        //   )
        // : [],
    };
  },
  components: {
    CreateTask: () => import("./CreateTask.vue"),
  },
  props: {
    RelationRecordId: {
      //关联ID
      type: String,
      default: "",
    },
    showCreateButton: {
      type: Boolean,
      default: true,
    },
    isShowButton: {
      type: Boolean,
      default: false,
    },
    buttonType: {
      type: String,
      default: "primary",
    },
    buttonSize: {
      type: String,
      default: "mini",
    },
  },
  methods: {
    handleCommand(command) {
      this.getFullScreen(true);
      //下拉菜单触发函数
      let viewType = this.taskTypeList.find((item) => item.ID === command);
      if (viewType) {
        if (viewType.FORMID) {
          this.$refs.CreateTaskForm.openDialog(viewType, 0);
        } else {
          this.$refs.CreateTask.OpenDialog(viewType, 0);
        }
      }
      // if (viewType.length > 0) {
      //   this.$refs.CreateTask.OpenDialog(viewType[0], 0);
      // }
    },
    getFullScreen(isBool) {
      if (this.IsShowOnlyList) {
        parent.setFullScreen(isBool);
      }
    },
    Success(row) {
      this.$emit("Success", row);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 16px;
}
.btn-normal {
  float: right;
  margin: 0 2px;
}
</style>
